import React, { useState } from "react";
import { api } from "@/lib/api";
import { usePoll, fmtUSDT } from "@/components/common";

const LABELS = {
  deposit_credit: "Deposit credited", hold_reserve: "Reserved for order", hold_release: "Hold released",
  sale_finalize: "Sale finalized", manual_add: "Manual addition", manual_deduct: "Manual deduction",
  excess_inr_deduction: "Excess INR deduction",
};

export default function Transactions() {
  const [ledger, setLedger] = useState([]);
  usePoll(() => api.get("/customer/transactions").then((r) => setLedger(r.data)).catch(() => {}), 8000, []);

  return (
    <div className="space-y-6">
      <h1 className="font-heading text-2xl sm:text-3xl font-bold text-slate-900">Transaction History</h1>
      <div className="bg-white border border-slate-200 rounded-2xl p-5">
        {ledger.length === 0 ? <div className="text-sm text-slate-400 py-10 text-center">No transactions yet.</div> : (
          <div className="overflow-x-auto scrollbar-thin">
            <table className="w-full text-sm" data-testid="transactions-table">
              <thead><tr className="text-left text-xs uppercase tracking-wider text-slate-400 border-b border-slate-200">
                <th className="py-2 pr-4">Ref</th><th className="py-2 pr-4">Type</th><th className="py-2 pr-4">Amount</th><th className="py-2 pr-4">Reason</th><th className="py-2">When</th>
              </tr></thead>
              <tbody>
                {ledger.map((t) => (
                  <tr key={t.id} className="border-b border-slate-100">
                    <td className="py-2.5 pr-4 font-mono text-xs text-slate-400">{t.ref}</td>
                    <td className="py-2.5 pr-4 font-medium text-slate-800">{LABELS[t.entry_type] || t.entry_type}</td>
                    <td className="py-2.5 pr-4 font-mono">{fmtUSDT(t.amount)}</td>
                    <td className="py-2.5 pr-4 text-slate-500 max-w-sm truncate">{t.reason}</td>
                    <td className="py-2.5 text-slate-400 whitespace-nowrap">{new Date(t.timestamp).toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
